import * as React from "react";

import { RESEND_COOLDOWN_SECONDS } from "@/constants/smsAuthCode";

const secondsUntil = (deadline: number): number => Math.max(0, Math.ceil((deadline - Date.now()) / 1000));

// 認証コードを再送できるようになるまでのカウントダウン。
// 残り秒数は「再送できる時刻」から都度計算する。setInterval の回数で数えると、
// アプリがバックグラウンドに回ってタイマーが止まった分だけ API の制限より長く待たせてしまうため
export const useResendCooldown = (initialSeconds: number = RESEND_COOLDOWN_SECONDS) => {
  const [deadline, setDeadline] = React.useState<number>(() => Date.now() + Math.max(0, initialSeconds) * 1000);
  const [remaining, setRemaining] = React.useState<number>(() => secondsUntil(deadline));

  React.useEffect(() => {
    const tick = () => {
      const next = secondsUntil(deadline);
      setRemaining(next);
      return next;
    };
    if (tick() === 0) return undefined;
    const id = window.setInterval(() => {
      if (tick() === 0) window.clearInterval(id);
    }, 1000);
    return () => window.clearInterval(id);
  }, [deadline]);

  // 再送成功時は既定の間隔で、429 のときは API が返した残り秒数で数え直す
  const restart = React.useCallback((seconds: number = RESEND_COOLDOWN_SECONDS) => {
    const nextDeadline = Date.now() + Math.max(0, seconds) * 1000;
    setDeadline(nextDeadline);
    setRemaining(secondsUntil(nextDeadline));
  }, []);

  return { remaining, canResend: remaining === 0, restart };
};
